import { useEffect } from 'preact/hooks'
function runObserver() {
  const checkoutButton = document.querySelector('#checkout-btn')
  const config = {
    childList: false,
    subtree: false,
    attributes: true
  }

  const mutationFunction = (mutations) => {
    for (const mutation of mutations) {
      if (mutation.attributeName === 'class' && checkoutButton.classList.contains('disabled') && mutation.attributeName !== 'scafg_handled') {
        checkoutButton.classList.remove('disabled')
        checkoutButton.removeAttribute('disabled')
      }
    }
  }

  const mutationObserver = new MutationObserver(mutationFunction)
  mutationObserver.observe(checkoutButton, config)
}

function CartCheckout({ type, className, disabled }) {
  const isMiniCart = type === 'mini-cart'

  useEffect(() => {
    runObserver()
  }, [])

  return (
    <div className={className}>
      <button id="checkout-btn" type="submit" name="checkout" className={`flex-1 w-full button-primary ${disabled ? 'button-disabled' : ''}`}>
        {isMiniCart ? 'Checkout' : 'Go to checkout'}
      </button>
      {isMiniCart && (
        <a href="/cart" className="flex-1 button-outlined">
          View bag
        </a>
      )}
    </div>
  )
}

export default CartCheckout
